import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV180({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.8.0" date="8th December 2025" title="We think you're going to love this one!">
      <p className="text-gray-300 mb-4">Here's what's new:</p>
      <p className="text-gray-300 mb-4">All venue members will now receive a notification 6 hours before a game is scheduled to start or a one off game is scheduled to start. The members can then respond to the notification and let everyone belonging to the venue know if they are going to attend the game.</p>
      <p className="text-gray-300 mb-4">The backend clock management engine has been rewritten for improved performance to cater for large number of games</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        <li>• 6 hours before games start members will receive a notification to let them know the game is about to start</li>
        {createClickableListItem('Members can respond to the notification and let everyone belonging to the venue know if they are going to attend the game', '/v1.8.0/attendance1.png')}
        <li>• The backend clock management engine has been rewritten!</li>
        <li>• Some minor frontend enhancements</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.8.0/attendance1.png', 'See who is attending the game')}
          {createThumbnail('/v1.8.0/attendance2.png', 'Send messages to all members of the venue')}
        </div>
      </div>
    </ReleaseCard>
  );
}
